module.exports = __webpack_public_path__ + "img/free-products-icon.71f1bfc3.svg";